import httpClient from '../utils/httpClient';
import { API_ENDPOINTS } from '../config/api';

export const adminService = {
  // --- Stats ---
  async getStats() {
    return httpClient.get(API_ENDPOINTS.ADMIN.STATS);
  },

  // --- Bookings ---
  async getAllBookings() {
    return httpClient.get(API_ENDPOINTS.BOOKINGS.ALL);
  },

  async updateBookingStatus(id, status) {
    return httpClient.put(`${API_ENDPOINTS.BOOKINGS.UPDATE_STATUS(id)}?status=${status}`);
  },

  async deleteBooking(id) {
    return httpClient.delete(API_ENDPOINTS.BOOKINGS.DELETE(id));
  },

  // --- Contacts ---
  async getAllContacts() {
    return httpClient.get(API_ENDPOINTS.CONTACT.ALL);
  },

  async markContactProcessed(id) {
    return httpClient.put(API_ENDPOINTS.CONTACT.MARK_PROCESSED(id));
  },

  // --- Special Offers ---
  async getAllSpecialOffers() {
    return httpClient.get(API_ENDPOINTS.SPECIAL_OFFER.ALL);
  },

  // --- Horoscopes ---
  async getHoroscopesByPeriod(zodiacSign, periodType) {
    return httpClient.get(API_ENDPOINTS.HOROSCOPES.BY_SIGN_AND_PERIOD(zodiacSign, periodType));
  },

  async updateHoroscope(zodiacSign, periodType, content, periodDate) {
    return httpClient.put(API_ENDPOINTS.HOROSCOPES.UPSERT(zodiacSign, periodType), { content, periodDate });
  }
};

export default adminService;
